import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
declare var $: any;

@Component({
    selector: 'ups-ham-menu-item',
    template: require('./ups-ham-menu-item.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsHamMenuItemComponent implements OnInit {
    
    @Input() type: string = '';
    @Input() linkHref: string;
    @Input() itemDisabled: boolean;
    @Input() idactions: string;

    private _itemMsgs = new Subject();

    get isFocusable(): boolean {
        if (this.type == 'button' || this.type == 'link') {
            return true;
        }

        return false;
    }

    get itemMsgs() {
        return this._itemMsgs;
    }
  

    ngOnInit() {

    }

    @ViewChild('menuItemBtn', { static: false }) menuItemBtn: ElementRef;
    setFocus(): void {
        if (this.menuItemBtn) {
            this._itemMsgs.next({
                msg: 'focus'
            });

            setTimeout(() => {
                this.menuItemBtn.nativeElement.focus();
            });
        }
    }


    callAndCloseMenu(): void {
        //if (this.clickEvt) {
        //    this.clickEvt();
        //}

        this._itemMsgs.next({
            msg: 'closeMenu'
        });
    }

    chkLinkKeydown(e): void {
        var key = (e.keyCode || e.which);

        if (key == 32) {
            this.callAndCloseMenu();
            e.preventDefault();
        }
    }
   

}


